import React from 'react';
import RotatableImage from '../utils/RotatableImage';

const ImageModal = ({ isOpen, image, alt, onClose }) => {
    if (!isOpen) return null;
    if (!image) return (
        <div
            className="fixed inset-0 z-50 flex items-center font-bold text-lg justify-center bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative max-w-full max-h-full min-w-[250px] min-h-[300px] p-4 bg-white rounded-md shadow-lg flex items-center justify-center"
                onClick={(e) => e.stopPropagation()}
            >
                NO IMAGE FOUND
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl leading-none"
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>
        </div>
    );

    // Check if the media is a video by looking at the file extension
    const isVideo = image && /\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(image);
    const isPDF = image && /\.pdf(\?.*)?$/i.test(image);

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm"
            onClick={onClose}
        >
            <div
                className="relative p-4 bg-white rounded-md shadow-lg flex flex-col items-center"
                style={{ maxWidth: '95vw', maxHeight: '95vh' }}
                onClick={(e) => e.stopPropagation()}
            >
                {isVideo ? (
                    <video
                        controls
                        autoPlay
                        className="rounded-md"
                        style={{ maxWidth: '90vw', maxHeight: '80vh' }}
                    >
                        <source src={image} type="video/mp4" />
                        <source src={image} type="video/webm" />
                        <source src={image} type="video/ogg" />
                        Your browser does not support the video tag.
                    </video>
                ) : isPDF ? (
                    <div className="flex flex-col items-center gap-4" style={{ width: 'min(90vw, 800px)', height: '80vh' }}>
                        <iframe
                            src={image}
                            title="PDF Preview"
                            className="w-full flex-1 rounded border"
                        />
                        <a
                            href={image}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 text-sm"
                        >
                            Open PDF in new tab
                        </a>
                    </div>
                ) : (
                    <RotatableImage
                        src={image}
                        alt={alt}
                        className="rounded-md"
                        style={{ maxWidth: '90vw', maxHeight: '80vh', objectFit: 'contain' }}
                    />
                )}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl leading-none bg-white rounded-full w-8 h-8 flex items-center justify-center shadow"
                    aria-label="Close modal"
                >
                    &times;
                </button>
            </div>
        </div>
    );
};

export default ImageModal;
